export const tourGuideSteps = [
  {
    selector: "#enable-notification-button",
    content:
      "Checkbox option to enable or disable notifications sent from MCC to your registered email address.",
  },
  {
    selector: "#update-create-user-button",
    content:
      "Press the Update User button to make changes to your user preference as selected above.",
  },
];

export const eulaStep = {
  selector: "#show-eula-button",
  content:
    "Press the Show EULA button to read the current EULA.",
};
